import { render, staticRenderFns } from "./RequireTabs.vue?vue&type=template&id=660fb019"
import script from "./RequireTabs.vue?vue&type=script&lang=js"
export * from "./RequireTabs.vue?vue&type=script&lang=js"
import style0 from "./RequireTabs.vue?vue&type=style&index=0&id=660fb019&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('660fb019')) {
      api.createRecord('660fb019', component.options)
    } else {
      api.reload('660fb019', component.options)
    }
    module.hot.accept("./RequireTabs.vue?vue&type=template&id=660fb019", function () {
      api.rerender('660fb019', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/require/components/RequireTabs.vue"
export default component.exports